import React from "react";
import { Button } from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import BankForm from "./BankForm";

interface ModalBankFormProps {
  isOpen: boolean;
  setClose: (modalState: boolean) => void;
  value: unknown;
  onSubmit: (value: unknown) => void;
}

const ModalBankForm = ({
  isOpen, setClose, onSubmit, value,
}: ModalBankFormProps) => (
  <Modal
    isOpen={isOpen}
    setOpen={setClose}
    title={`${value ? "Edit data" : "Tambah data"} - master bank`}
    body={
      <BankForm defaultValue={value} onClose={() => setClose(false)} onSubmit={onSubmit} />
    }
    footer={
      <div className="action-container">
        <Button
          variant="text"
          type="button"
          onClick={() => setClose(false)}
        >
          Batal
        </Button>
        <Button>
          Simpan
        </Button>
      </div>
    }
  />
);

export default ModalBankForm;
